// Offer selectors

import { getDefaultOfferCode as getDefaultOfferCodeFromReducer } from './offer.reducer';

export const getDefaultOfferCode = state => getDefaultOfferCodeFromReducer(state.code);

export const getOfferCode = state => state.code;

export const getOfferCodeDescription = state => state.description;

export const getOfferCodeErrorMessage = state => state.errorMessage;

export const getActiveOffers = state => state.activeOffers;

export const getEmailActiveOffers = state => state.emailOffers;

export const getIsOfferAppliedViaPromoBanner = state => Boolean(state.appliedViaPromoBanner);

export const getOfferPromoBannerPersonalization = state => state?.promoBannerPersonalization ?? null;

export const getTotalActiveOffers = state => {
  const activeOffers = state.offer.activeOffers;
  if (activeOffers.length > 0) {
    const userOffers = state.account?.currentLoggedInUser?.offerList;
    const offerstotal = activeOffers?.reduce((accumulator, currentValue) => {
      const offer = userOffers?.find(offer => offer.id === currentValue);
      return accumulator + offer?.dollarValue;
    }, 0);
    return offerstotal;
  }
  return 0;
};

export const getAvailableOffers = state => {
  const userOffers = state.account.currentLoggedInUser.offerList || [];
  return userOffers;
};
